import { createFileRoute } from "@tanstack/react-router";
import { ProjektoekonomiPage, projektoekonomiHead } from "@/pages/ProjektoekonomiPage";

export const Route = createFileRoute("/projektoekonomi")({
  head: () => projektoekonomiHead("da"),
  component: () => <ProjektoekonomiPage locale="da" />,
});
